/* src/app/builder-screen-beta/event-scripting/simple-mode/template-configurator.component.scss */
.template-configurator {
  padding: 16px 0;
}
.config-item {
  margin-bottom: 16px;
}
.config-item:last-child {
  margin-bottom: 0;
}
nz-form-label {
  font-weight: 500;
  color: #262626;
}
/*# sourceMappingURL=template-configurator.component.css.map */
